import { supertypeClass, property, Persistable, Remoteable, Supertype } from '@haventech/amorphic';

import { Account } from '../Account';
import { Deprecable } from '../../Deprecable';

export interface FullIdentity extends Partial<Identity> {
  email: string;
}

export enum IdentitySource {
  SIGN_UP = 'SIGN_UP',
  MANUAL_LINK = 'MANUAL_LINK',
}

export enum IdentityProviders {
  AUTH0 = 'auth0',
  GOOGLE = 'google-oauth2',
  FACEBOOK = 'facebook',
  AMC = 'amc',
}

export const IdentityProvidersDisplayName = {
  [IdentityProviders.GOOGLE]: 'Google',
  [IdentityProviders.FACEBOOK]: 'Facebook',
  [IdentityProviders.AUTH0]: 'Email/Password',
  [IdentityProviders.AMC]: 'Email/Password',
};

@supertypeClass({ toClient: true, toServer: false })
export class Identity extends Persistable(Remoteable(Supertype)) implements Deprecable {
  @property({
    toServer: false,
    toClient: true,
    comment: 'true if the identity is active.  Can be deactivated by delinking or disabling an identity',
  })
  isActive: boolean;

  @property({
    toServer: false,
    toClient: true,
    comment: 'identity provider - e.g. auth0 or google or facebook or amc',
  })
  provider: string;

  @property({
    toServer: true,
    toClient: false,
    comment: 'unique identifier supplied by the provider',
  })
  identifier: string;

  @property({
    toClient: true,
    toServer: false,
    getType: () => Account,
  })
  account: Account;

  @property({
    toServer: false,
    toClient: true,
    comment: 'source based on how the identity was linked.  e.g. sign up or manual linking',
  })
  source: IdentitySource;

  @property({
    toServer: false,
    toClient: true,
    comment: 'is this the primary user identity',
  })
  isPrimary: boolean;

  @property({
    toServer: false,
    toClient: true,
    comment: 'if true the user cannot login with this identity',
  })
  isLocked: boolean;

  private constructor() {
    super();
  }

  static new(identifier: string): Identity {
    return new Identity().init(identifier);
  }

  private init(identifier: string): Identity {
    this.identifier = identifier;
    this.isActive = true;

    return this;
  }
}
